/**
 * Resolve the legacy per-user claim cap (maxClaimsPerUser → backend maxClaimSize)
 * that gets persisted for a campaign.
 *
 * IRL2-2975: for quiz/survey campaigns the cap IS the configured "Max Attempts"
 * (quizConfig.attemptLimit). It must mirror that value in BOTH directions — the
 * previous one-way `Math.max(maxClaimsPerUser, attemptLimit)` floor meant a value
 * below the maxClaimsPerUser default (3) never propagated, so "Max Attempts = 2"
 * still let the player claim 3 times. The only legitimate floor is `dropsPerDrop`
 * (you cannot claim fewer than one drop's worth).
 */
export function resolveMaxClaimsPerUser(opts: {
  experience?: string | null
  attemptLimit?: number | null
  maxClaimsPerUser: number
  dropsPerDrop: number
}): number {
  const { experience, attemptLimit, maxClaimsPerUser, dropsPerDrop } = opts
  const isQuizLike = experience === 'quiz' || experience === 'survey'
  // For quiz/survey, the configured Max Attempts is authoritative; fall back to the
  // existing drop cap only when it is not set. Non-quiz campaigns keep their own cap.
  const base = isQuizLike ? (attemptLimit ?? maxClaimsPerUser) : maxClaimsPerUser
  return Math.max(base, dropsPerDrop)
}
